import React, { FunctionComponent } from 'react';
import { isEmpty } from 'lodash';
import { Navigate, Route, useMatch, generatePath } from 'react-router-dom';

import { useIsSpeechCraftMFE } from 'hooks';
import { useAppContext } from 'contexts/AppContext';
import { DashboardRoutes as Routes, AppRoutes } from 'routes';

interface PrivateRouteProps {
  children: React.ReactNode;
  roles?: string[];
  ispublic?: boolean;
}

const PrivateRoute: FunctionComponent<PrivateRouteProps> = ({ 
  roles = [], 
  ispublic = false,
  children 
}) => {
  const isSpeechCraftMFE = useIsSpeechCraftMFE();
  const { roles: userRoles = [] } = useAppContext();

  const hasAcccess =
    isEmpty(roles) ||
    userRoles?.[0]?.roles?.some((userRole: any) =>
      roles.includes(userRole.positionCode),
    );

  const isCourseListingPage = useMatch(Routes.COURSE_LIST.path);
  const isClubMemberProfilePage = useMatch(Routes.PROFILE.path);
  const isClubDetailPage = useMatch(Routes.CLUB_DETAILS.path);
  const isMyClubPage = useMatch(Routes.CLUBS.path);
  const isErrorPage = useMatch(AppRoutes.ERROR.path);

  const isInvalidRoute =
    isSpeechCraftMFE &&
    (isCourseListingPage ||
      isClubMemberProfilePage ||
      isClubDetailPage ||
      isMyClubPage);

  if (ispublic) return <>{children}</>;

  if (!isErrorPage && (!hasAcccess || isInvalidRoute)) {
    return <Navigate to={generatePath(AppRoutes.ERROR.path)} replace />;
  }

  return <>{children}</>;
};

export default PrivateRoute;
